module.exports = __webpack_public_path__ + "3135171c3f6948d1f7e496f06f49338a.pdf";